/**
 * ProtectedRoute Component
 * Protege rutas que requieren autenticación
 */

import React from 'react';
import { Navigate } from 'react-router-dom';

import Loading from './Loading';
const ProtectedRoute = ({ children, isAuthenticated, loading }) => {
  if (loading) {
    return (
      <Loading />
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
